/** Shared side-icon frame. Hotel and train use this image size; flight uses the same slot so the input width does not change with the tab. */
export const HOMEPAGE_AI_GUIDE_MASCOT_WIDTH = 177;
export const HOMEPAGE_AI_GUIDE_MASCOT_HEIGHT = 118;
